import { archiveImgs } from "@/mocks/heiliao";

export default function ArchiveGrid() {
  return (
    <section id="archive" className="scroll-mt-20 bg-background-50 py-10 md:py-16">
      <div className="mx-auto w-full max-w-[1240px] px-4 md:px-6">
        <div className="mb-6 flex flex-col justify-between gap-4 md:flex-row md:items-end">
          <div>
            <div className="mb-1 flex items-center gap-2 text-xs font-bold tracking-widest text-primary-600">
              <i className="ri-gallery-fill text-sm"></i>原帖存档
            </div>
            <h2 className="font-heading text-2xl font-black text-foreground-950 md:text-3xl">
              证据留档，按时间存好
            </h2>
            <p className="mt-2 max-w-lg text-sm text-foreground-500">
              截图、录音、流水与帖子我们都做了归档编号。留档是为了让后来的人也能对照，而不是越删越「没有」。
            </p>
          </div>
          <a
            href="#faq"
            className="whitespace-nowrap rounded-full border border-foreground-300 px-4 py-2 text-sm text-foreground-700 transition-colors hover:border-primary-400 hover:text-primary-600"
          >
            更新得慢？点这里提线索
          </a>
        </div>

        <div className="grid grid-cols-2 gap-4 md:grid-cols-3 lg:grid-cols-4">
          {archiveImgs.map((a) => (
            <a
              key={a.src}
              href="#archive"
              className="group overflow-hidden rounded-xl border border-background-200 bg-background-100/70"
            >
              <div className="relative h-52 w-full overflow-hidden md:h-64">
                <img
                  src={a.src}
                  alt={a.type + "素材留档"}
                  title={a.type + "素材留档"}
                  className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute left-2 top-2 rounded-md bg-foreground-950/70 px-2 py-0.5 text-[11px] text-background-50 backdrop-blur">
                  {a.type}
                </div>
              </div>
              <div className="flex items-center justify-between px-3.5 py-3">
                <span className="text-xs text-foreground-500">{a.source}</span>
                <span className="flex items-center gap-1 text-xs font-bold text-primary-600">
                  查看
                  <i className="ri-arrow-right-up-line transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5"></i>
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}